/**
 * Sync global notification email recipients from a PubSub event.
 */
export default function handleNotificationsEmailUpdated(event, userActions) {
  if (Array.isArray(event.data?.notificationsEmail)) {
    userActions.updateUser(
      { notificationsEmail: event.data.notificationsEmail },
      true,
    );
  }
}
